const headline1 = (data) => {
  const node = data.node;
  const title = node.title;
  const serial = data.num;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "cwSctyJajd",
        width: 381.1087664041995,
        height: 439.91254593175853,
        left: 567.4210498687664,
        top: 122.58750656167987,
        viewBox: [381.1087664041995, 439.91254593175853],
        path: "M 95.27719160104988 0 L 381.1087664041995 0 L 285.83157480314964 439.91254593175853 L 0 439.91254593175853 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        pathFormula: "parallelogramLeft",
        keypoint: 0.25,
      },
      {
        type: "shape",
        id: "8bn-5ekT3Z",
        width: 49.69847769028871,
        height: 49.69847769028871,
        left: 0,
        top: 513.801469816273,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lkLmRA_3ex",
        width: 977.0455643044619,
        height: 49.69847769028871,
        left: 22.95443569553806,
        top: 513.801469816273,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "XquCgkWiiH",
        width: 43.392860892388455,
        height: 30.14299212598425,
        left: 0,
        top: 533.3570603674541,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "K2CaXOKOg5",
        width: 339.55559055118107,
        height: 436.2062992125984,
        left: 563.1659951529545,
        top: 0,
        viewBox: [339.55559055118107, 436.2062992125984],
        path: "M 84.88889763779527 0 L 339.55559055118107 0 L 254.66669291338582 436.2062992125984 L 0 436.2062992125984 Z",
        fill: `${color}c7`,
        fixedRatio: false,
        rotate: 0,
        pathFormula: "parallelogramLeft",
        keypoint: 0.25,
      },
      {
        type: "text",
        id: "HHozHxWR1f",
        width: 712.2145931758531,
        height: 109.0625,
        left: 61.78771653543308,
        top: 195.36428768058812,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: `<p style="text-align: left;"><span style="font-size: 59.375px;font-family: Microsoft Yahei;">${serial}</span></p>`,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "bHWjNKv2SG",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "T_nUeKyYa0",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "yqRM2rccXo",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 27.249973753280837,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SfXMuCGYcS",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2g7XEiHYPQ",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7YuSkL1JrA",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 41.71181102362205,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "WiHUHf0ayg",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 927.4434645669292,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "MQ2hmJ7nDR",
        width: 7.36241469816273,
        height: 7.0890288713910765,
        left: 962.6375853018372,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "EQnMdvC44b",
        width: 35.77753280839895,
        height: 7.0890288713910765,
        left: 930.6410498687665,
        top: 56.173648293963254,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "OnUT9yc1Xj",
        width: 592.6591076115485,
        height: 57.5,
        left: 61.78771653543308,
        top: 290.2499737532808,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: `<p style="text-align: left;"><span style="font-size: 25px;font-family: Microsoft Yahei;">${title}</span></p>`,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "line",
        id: "C474dxBu28",
        width: 2,
        left: 69.50598561459175,
        top: 383.85112793572307,
        start: [0, 0],
        end: [142.22225721784775, 0],
        style: "solid",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "shape",
        id: "I-wT0x2S8D",
        left: 201.79475046353525,
        top: 374.35298207663783,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "E_UpGELZ4-",
        left: 69.50598561459175,
        top: 171.58750656167987,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "Wm9hue6U22",
        left: 82.50598561459175,
        top: 171.58750656167987,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
      {
        type: "shape",
        id: "9dBKEp9Cxk",
        left: 96.12081569222883,
        top: 171.58750656167987,
        width: 15,
        height: 15.451174289245984,
        viewBox: [200, 200],
        path: "M 0 0 L 80 0 L 200 100 L 80 200 L 0 200 L 120 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default headline1;
